export default __webpack_public_path__ + "static/media/d_interface_design.c74a29fe.png";